<div
  #scrollArea
  class="absolute origin-top-left will-change-transform"
  [style]="{
    transform:
      'translate(' + zoom().x + 'px, ' + zoom().y + 'px) scale(' + zoom().k + ')',
  }"
>
  <ng-template #tree let-treeNode>
    <li>
      @if (treeNode.id !== rootId()) {
        <span [attr.data-unit-id]="treeNode.id">
          <ng-template
            [ngTemplateOutlet]="nodeTemplate() ?? null"
            [ngTemplateOutletContext]="{ $implicit: treeNode }"
          ></ng-template>
        </span>
      } @else {
        <span [attr.data-unit-id]="treeNode.id">
          <ng-template
            [ngTemplateOutlet]="rootTemplate() ?? null"
            [ngTemplateOutletContext]="{ $implicit: treeNode }"
          >
          </ng-template>
        </span>
      }

      @if (treeNode.children.length) {
        <ul>
          @for (node of treeNode.children; track $index) {
            <ng-template
              [ngTemplateOutlet]="tree"
              [ngTemplateOutletContext]="{ $implicit: node }"
            ></ng-template>
          }
        </ul>
      }
    </li>
  </ng-template>

  @if (nodes().length) {
    <ul>
      @for (node of nodes(); track $index) {
        <ng-template
          [ngTemplateOutlet]="tree"
          [ngTemplateOutletContext]="{ $implicit: node }"
        ></ng-template>
      }
    </ul>
  }
</div>
